export default {
  title: "System notifications",
  eventNameInputPlaceholder: "Exhibition Name",
  typeNotificationTitle: "Type",
  notifications: "Notifications",
  allNotifications: "All notifications",
  readAllNotification: "Mark everything as read",
  showMore: "Show more",
  showAll: "Show all",
  emailNotification: "E-mail notification",
  notNotifications: "No notifications",
  searchCompany: "Search by company",
  noServicesFound: "Services not found",
  typeNotification: {
    exhibition_personal_pass_registration_deadline:
      "Issuing of exhibitor passes to {event} ends on {date}.",
    exhibition_personal_pass_print_closes:
      "Printing of exhibitor passes to {event} ends on {date}.",
    exhibition_mounting_pass_print_closes:
      "Printing of assembly/dismantling passes to {event} ends on {date}.",
    exhibition_mounting_pass_registration_deadline:
      "Issuing of assembly/dismantling passes to {event} ends on {date}.",
    exhibition_catalogue_placement_deadline:
      "Submission of applications for placement in the {event} Official Catalogue closes on {date}.",
    exhibition_car_pass_ready:
      "You can print/download a one-time vehicle pass on {event}.",
    exhibition_personal_pass_registration_deadline_company:
      "For the company «{company}» issuing of exhibitor passes to {event} ends on {date}.",
    exhibition_personal_pass_print_closes_company:
      "For the company «{company}» printing of exhibitor passes to {event} ends on {date}.",
    exhibition_mounting_pass_print_closes_company:
      "For the company «{company}» printing of assembly/dismantling passes to {event} ends on {date}.",
    exhibition_mounting_pass_registration_deadline_company:
      "For the company «{company}» issuing of assembly/dismantling passes to {event} ends on {date}.",
    exhibition_catalogue_placement_deadline_company:
      "For the company «{company}» submission of applications for placement in the {event} Official Catalogue closes on {date}.",
    exhibition_car_pass_ready_company:
      "For the company «{company}» you can print/download a one-time vehicle pass on {event}.",
    exhibition_invoice_ready_company:
      "Invoices for {event} are available in the Documents section.",
    exhibition_act_ready_company:
      "Acceptance certificates for {event} are available in the Documents section.",
    paid_pass_available_at_service_bureau_company:
      "A vehicle / promoter pass paid for by your company for {event} should be received at the Service Bureau.",
    payment_has_not_been_made_in_full_company:
      "Payment has not been made in full. Invoices for {event} are available in the Documents section."
  },
  emailNotifications: {
    certificate_email_notify: "Exhibitor passes",
    installation_email_notify: "Assembly/dismantling passes",
    car_pass_email_notify: "Paid passes",
    catalog_order_email_notify: "Publication in the Catalogue",
    document_email_notify: "Acceptance certificates",
    additional_services: "Ordering additional services"
  }
};
